import {
	AUDIO_GROUP_TYPE,
	COLLECTION_NAMES,
	COLLECTION_SLUGS,
} from "../../models/dictionary";
import type {
	FreeGroupModel,
	FavoritesGroupModel,
	CustomBlendGroupModel,
} from "../../models/models";

export const freeGroup: FreeGroupModel = {
	id: "free",
	name: "Free",
	slug: "free",
	type: AUDIO_GROUP_TYPE.FREE,
	imageUrlStub: "https://images.coffitivity.com/free",
	description:
		"Experience the power of sound — on us. Enjoy this selection of free tracks designed to boost creativity, focus, and relaxation. Whether you're working, studying, or unwinding, these immersive soundscapes help you find your flow.",
};

export const favoritesGroup: FavoritesGroupModel = {
	id: "favorites",
	name: "Favorites",
	slug: "favorites",
	type: AUDIO_GROUP_TYPE.FAVORITES,
	imageUrlStub: "https://images.coffitivity.com/favorites",
	description: "All of your favorite tracks, always within arms reach.",
	tracks: [],
};

export const customBlendGroup: CustomBlendGroupModel = {
	id: "custom-blends",
	slug: COLLECTION_SLUGS.CUSTOM_BLEND,
	name: COLLECTION_NAMES.CUSTOM_BLEND,
	type: AUDIO_GROUP_TYPE.CUSTOM_BLEND,
	imageUrlStub: "https://images.coffitivity.com/custom-blends",
	description:
		"Your personalized blends, crafted to your unique tastes and preferences.",
};
